import { nanoid } from 'nanoid'

/* @ngInject */
function CampaignActionsListController ($scope, $rootScope, $timeout, $translate, CampaignActionService, ToastService, ConfirmationModalService) {
  $scope.companyFeatures = {
    artsAccess: false,
    postsAccess: false,
    auditAccess: false
  }

  $scope.loading = {}

  $scope.actions = []

  const api = {
    _getCampaignActions,
    _selectAction
  }

  $scope.selectedAction = null

  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getCompanyFeaturesAndAddons()
      .then((companyFeatures) => {
        $scope.features = companyFeatures.features

        const hasArts = $scope.features['ARTS.ACCESS']
        const hasPosts = $scope.features['POSTS.ACCESS']
        const hasChecklist = $scope.features['CHECKLIST.ACCESS']

        $scope.companyFeatures.artsAccess = hasArts
        $scope.companyFeatures.postsAccess = hasPosts
        $scope.companyFeatures.auditAccess = hasChecklist
      })

    api._getCampaignActions()
  }

  const deregisterActionsWatcher = $scope.$watch('actions', function (newActions) {
    $rootScope.$emit('campaign.actions-changed', newActions)
  }, true)

  const deregisterAttachPostNewAction = $rootScope.$on('campaign.attach-post-new-action', function (event, post) {
    $scope.addNewAction('POST', { post })
    ToastService.showSuccessToast($translate.instant('campaignEdit.actions.assetAttachedToast'))
  })

  const deregisterAttachChecklistNewAction = $rootScope.$on('campaign.attach-checklist-new-action', function (event, checklist) {
    $scope.addNewAction('AUDIT', { checklist })
    ToastService.showSuccessToast($translate.instant('campaignEdit.actions.assetAttachedToast'))
  })

  const deregisterAttachMaterialNewAction = $rootScope.$on('campaign.attach-material-new-action', function (event, materials) {
    $scope.addNewAction('ART', { materials })
    ToastService.showSuccessToast($translate.instant('campaignEdit.actions.assetAttachedToast'))
  })

  const deregisterReloadActions = $rootScope.$on('campaign.reload-actions', function (event, actionId) {
    api._getCampaignActions(api._selectAction.bind(this, actionId))
  })

  $scope.$on('$destroy', () => {
    deregisterAttachPostNewAction()
    deregisterAttachChecklistNewAction()
    deregisterAttachMaterialNewAction()
    deregisterReloadActions()
    deregisterActionsWatcher()
  })

  $scope.addNewAction = (type, assets) => {
    if (!$scope.actions) $scope.actions = []

    const action = {
      id: nanoid(),
      type,
      customerCompanyId: $rootScope.oUser.customerCompanyId,
      expirationDate: undefined,
      isContentRequired: false,
      publicationDate: undefined,
      postId: undefined,
      posts: [],
      artIds: undefined,
      arts: [],
      briefingAuditId: undefined,
      briefingAudits: [],
      artCollectionIds: undefined,
      artCollections: []
    }

    if (assets?.post) {
      action.posts = [assets.post]
      action.postId = assets.post.id
    } else if (assets?.checklist) {
      action.briefingAudits = [assets.checklist]
      action.briefingAuditId = assets.checklist.id
    } else if (assets?.materials) {
      action.arts = assets.materials.filter(material => 'isTemplate' in material)
      action.artIds = action.arts.map(art => art.id)
      action.artCollections = assets.materials.filter(material => !('isTemplate' in material))
      action.artCollectionIds = action.artCollections.map(artCollection => artCollection.id)
    }

    $scope.actions.push(action)

    $timeout(() => {
      $('.campaign-actions-list-content campaign-action-item').last().click()
    }, 100)
  }

  $scope.selectAction = (event, action) => {
    const eventTarget = event.target.localName

    if ($scope.selectedAction === action && eventTarget !== 'uds-dropdown-menu-item') {
      $scope.selectedAction = null
    } else {
      $scope.selectedAction = null
      $scope.selectedAction = action
    }
    $scope.onActionSelect($scope.selectedAction)
  }

  function _getCampaignActions (callback) {
    CampaignActionService.getCampaignActions($scope.campaign.id).then((response) => {
      $scope.actions = response.rows
      $scope.actions.forEach(action => {
        action.publicationStatus = CampaignActionService.getPublicationStatus(action)
      })

      if (callback) callback()
    })
  }

  function _selectAction (actionId) {
    $timeout(() => {
      if (actionId) {
        $(`.campaign-actions-list-content .campaign-action-item-${actionId}`).click()
      } else {
        $('.campaign-actions-list-content campaign-action-item .action-item.selected').parent().click()
      }
    }, 100)
  }
}

export { CampaignActionsListController }
